import axios from "axios";
import router from "@/router";
import { partyAreasData } from "@/data/partyAreasData";

const state = {
  getUrl: "https://rays.fanportal-mlb.com/2024tickets/",
  getEpitch: {},
  getSummary: {},
  getIntroVideo: {},
  getSections: [],
  getAllSections: [],
  getPrimaryNav: [],
  getClient: {},
  getRep: {},
  sessionDbId: "",
  currentSection: "Welcome",
  mode: "live",
  // getSections: [
  //   "Landing",
  //   "Flex",
  //   "Traditional",
  //   "Flexible",
  //   "PremiumSeating",
  //   "CoreBenefits",
  //   "GiftOption",
  //   "PartyAreas",
  //   "SingleGameSuites",
  //   "LouisianaLedge",
  //   "Schedule",
  //   "Faq",
  //   "Summary",
  // ],
  // getPrimaryNav: [
  //   "Welcome",
  //   "Season Membership",
  //   "Traditional Membership",
  //   "Flexible Membership",
  //   "Premium Seating",
  //   "Season Member Benefits",
  //   "Gift Options",
  //   "Party Areas",
  //   "Single Game Suites",
  //   "Louisiana Hot Sauce Ledge",
  //   "Schedule",
  //   "Frequently Asked Questions",
  //   "Summary",
  // ],
};

const getters = {
  getEpitch: (state) => state.getEpitch,
  getSummary: (state) => state.getSummary,
  getClient: (state) => state.getClient,
  getRep: (state) => state.getRep,
  getSubSectionsByParent: (state) => (id) => {
    const subSections = state.getAllSections.filter(
      (area) => area.parentId === id
    );
    return subSections;
  },
};

const actions = {
  async fetchEpitch({ commit }) {
    const url = location.pathname.split("/");
    let purl = url[2];

    if (purl && purl.includes("preview.")) {
      purl = purl.replace("preview.", "");
      state.mode = "preview";
    }

    if (typeof purl === "undefined" || purl === "") {
      purl = "admin.0000";
    }

    axios
      .get(
        "https://rays.fanportal-mlb.com/2024tickets/api/SiteEndpoint.php?purl=" +
          purl.replace("/", "") +
          "&d=" +
          new Date().getTime()
      )
      .then(function(response) {
        if (response.data.status == "ok") {
          response.data.site.mode = state.mode;
          response.data.site.purl = purl;
          let pages = response.data.site.pages;
          let sections = pages;
          commit("setEpitch", response.data.site);
          commit("setSections", sections);
          commit("setAllSections", sections);
          commit("setSummary", sections);
          commit("setPrimaryNav", sections);
          commit("setClient", response.data.site.client);
          commit("setRep", response.data.site.rep);
          commit("setSectionsRoute", sections);
          if (state.mode != "preview") {
            axios
              .post(
                "https://rays.fanportal-mlb.com/2024tickets/api/EpitchLiteTracking.php",
                { method: "visit", purl: purl }
              )
              .then((response) => {
                //console.log(response.data);
                commit("setSessionDbId", response.data.sessionDbId);
              });
          }
        } else {
          //console.log("fetch error", response);
        }
      });
  },
  updateSection({ commit }, sectionId) {
    commit("UPDATE_SECTION");
  },
  postTracking({ commit }, sectionId) {
    commit("POST_TRACKING", sectionId);
  },
};

const mutations = {
  setEpitch: (state, payload) => {
    state.getEpitch = payload;
  },
  setSummary: (state, payload) => {
    state.getSummary = payload.filter(
      (section) => section.vueComponent === "Summary"
    );
  },
  setIntroVideo: (state, payload) => {
    state.getIntroVideo = payload;
  },
  setSections: (state, payload) => {
    payload.forEach((page) => state.getSections.push(page.vueComponent));
  },
  setAllSections: (state, payload) => {
    payload.forEach((page) => state.getAllSections.push(page));
  },
  setSectionsRoute: (state, payload) => {
    let routes = [];

    payload.forEach((page) => {
      if (page) {
        routes.push({
          path: `${page.vuePath}`,
          name: page.title,
          component: () =>
            import(
              `@/components/sections/${page.vueComponent}/${page.vueComponent}`
            ),
        });
      }
    });
    router.options.routes.push(...routes);
    router.addRoutes(routes);
  },
  setPrimaryNav: (state, payload) => {
    payload.forEach((page) => {
      if (page.primaryMenu) state.getPrimaryNav.push(page.title);
    });
  },
  setClient: (state, payload) => {
    state.getClient = payload;
  },
  setRep: (state, payload) => {
    state.getRep = payload;
  },
  setSessionDbId: (state, payload) => {
    state.sessionDbId = payload;
  },
  UPDATE_SECTION(state, sectionId) {
    state.currentSection = sectionId;
  },
  POST_TRACKING(state, sectionId) {
    if (state.mode != "preview") {
      let purl = state.getEpitch.purl;
      let sessionDbId = state.sessionDbId;
      //let sectionId = state.currentSection;
      //console.log("test", sectionId);
      axios
        .post(
          "https://rays.fanportal-mlb.com/2024tickets/api/EpitchLiteTracking.php",
          {
            method: "page",
            purl: purl,
            sessionDbId: sessionDbId,
            section: sectionId,
          }
        )
        .then((response) => {
          //console.log("Tracking Updated", response);
        });
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
